import type { JsonLd } from '@atlaskit/json-ld-types/jsonld';

import type { DependencyOutcome } from '../dependencyHealthAnalytics.ts';

import { isUnsupportedUrlError } from './unresolvableUrls.ts';

export const smartLinkResultOutcome = (
	response: JsonLd.Response | null | undefined,
): DependencyOutcome => {
	if (!response) {
		return 'unavailable';
	}
	const access = response.meta?.access;
	if (access === 'unauthorized' || access === 'forbidden') {
		return 'denied';
	}
	return 'succeeded';
};

export const smartLinkFailureOutcome = (error: unknown): DependencyOutcome => {
	if (isUnsupportedUrlError(error)) {
		return 'unsupported';
	}
	if (error instanceof Error && error.name === 'AbortError') {
		return 'cancelled';
	}
	if (error !== null && typeof error === 'object') {
		if ('kind' in error && error.kind === 'auth') {
			return 'denied';
		}
		if (
			'type' in error &&
			(error.type === 'ResolveTimeoutError' || error.type === 'TimeoutError')
		) {
			return 'timeout';
		}
	}
	return 'failed';
};
